module.exports = __webpack_public_path__ + "img/Weapon_101.5dcfc74f.png";